import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { injectIntl } from 'react-intl';
import _ from 'lodash';
import { withAccount } from '../../../../components/AccountContext';
import messages from '../intl-messages';


const LocalFieldList = ({ data, intl: { formatMessage } }) => {
  const [localFields, setLocalFields] = useState([]);

  useEffect(() => {
    if (data) {
      setLocalFields(
        _.sortBy(data.account.localAriFields, f => f.rank)
          .map(field => ({
            question: field.question,
            type: field.dataType,
          })),
      );
    }
  }, [data]);

  return (
    <div className="p-grid">
      {localFields.length === 0
        ? (
          <div style={{ textAlign: 'center', width: '100%' }}>
            <small>
              {formatMessage(messages.noLocalAriCreated)}
            </small>
          </div>
        )
        : (
          <>
            <div style={{ marginBottom: '10px', textAlign: 'center', width: '100%' }}>
              <small>
                {formatMessage(messages.fieldListCurrentFields)}
              </small>
            </div>
            <DataTable
              responsive
              value={localFields}
            >
              <Column
                field="question"
                header={formatMessage(messages.questionLabel)}
                style={{ fontStyle: 'italic' }}
              />
              <Column
                field="type"
                header={formatMessage(messages.typeLabel)}
              />
            </DataTable>
          </>
        )
      }
    </div>
  );
};

LocalFieldList.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withAccount(injectIntl(LocalFieldList));
